import { type RefObject, useEffect } from 'react'

export function useClickOutside(
  ref: RefObject<HTMLElement | null>,
  handleOnClickOutside: (event: MouseEvent | TouchEvent) => void,
) {
  useEffect(() => {
    function listener(event: MouseEvent | TouchEvent) {
      const path = event.composedPath()

      if (!ref.current) return

      if (path.includes(ref.current)) return

      // Prevent triggering onClickOutside when clicking inside a Skapa sheet/modal
      const isSkapaSheet = path.some((node) => {
        if (!(node instanceof HTMLElement)) return false
        return node.getAttribute('data-element-name') === 'skapa-sheet'
      })
      if (isSkapaSheet) return

      const isInteractive = path.some((node) => {
        if (!(node instanceof HTMLElement)) return false
        const tag = node.tagName.toLowerCase()
        return tag === 'button' || tag === 'a'
      })
      if (isInteractive) return

      handleOnClickOutside(event)
    }

    document.addEventListener('mousedown', listener)
    document.addEventListener('touchstart', listener)

    return () => {
      document.removeEventListener('mousedown', listener)
      document.removeEventListener('touchstart', listener)
    }
  }, [ref, handleOnClickOutside])
}
